import React, { useEffect } from 'react';
import
{
    Box,
    // List,
    ListItem,
    Card,
    CardContent,
    Typography,
    Checkbox
    // Accordion,
    // AccordionSummary,
    // AccordionDetails
} from '@mui/material';
import { useState } from '@hookstate/core';
import { makeStyles } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
import { useEventState } from '../../stores/eventStore';
import EnhancedTableToolbar from '../../sharedcomponents/tableToolbar/tableToolbar';
import Paging from '../../sharedcomponents/pagination/pagination';
import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import Title from '../../sharedcomponents/title/title';
import DataSocialResRow from './dataSocialResRow';
import CircleIcon from '@mui/icons-material/Circle';

// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const theme = createTheme();

const useStyles = makeStyles(() => ({
    boxContent: {
        // paddingTop: theme.spacing(2),
    },
    listContent: {
        paddingBottom: theme.spacing(0),
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
    accordionMain: {
        '& .MuiButtonBase-root': {
            '& .Mui-expanded': {
                // minHeight: theme.spacing(4)
            },
        },
    },
    count: {
        position: 'absolute',
        // lineHeight: 0.5,
        color: '#fff',
        fontWeight: 500,
        // top: '0.5em',
        fontSize: '0.8em',
    },
    accordion: {
        backgroundColor: '#cccccc',
    },
    icon: {
        fontSize: '1.5em',
    },
    wrapper: {
        position: 'relative',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        top: '7px'
    },
    accordionHeader: {
        textTransform: 'uppercase',
        fontWeight: 600,
    },
}));

// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const DataSocialResList = (props) =>
{
    const classes = useStyles();
    const [listData, setListData] = React.useState([]);
    const [allListData, setAllListData] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const [filterListData, setFilterListData] = React.useState([]);
    const eventState = useEventState();
    const moduleIndex = useState(0);
    const [checkAllSelect, setCheckAllSelect] = React.useState(false)


    useEffect(() =>
    {
        setCheckAllSelect(false)
        if(props.allData){
            setAllListData(props.allData)
        }
        if (listData && listData.length == 0 && filterListData.length == 0)
        {
            setListData(props.data);
            setFilterListData(props.data);
        } else if (
            props.showSearchRec &&
            props.data.length != listData.length
        )
        {
            setListData(props.data);
            setFilterListData(props.data);
        } else if (!props.showSearchRec)
        {
            setListData(props.data);
            setFilterListData(props.data);
        }

        if (
            eventState &&
            eventState.eventDetail.get() != null &&
            props.moduleToShow != undefined
        )
        {
            getModuleDetailsData();
        }
    }, [props]);

    const getModuleDetailsData = () =>
    {
        const index = eventState.eventDetail
            .get()
            .moduleDetails.findIndex((element) =>
            {
                if (element.moduleName === props.moduleToShow)
                {
                    return true;
                }
            });
        moduleIndex.set(index);
    };

    const handleOnChange = (event) =>
    {
        let str = event.target.value;
        const value = str.replace(/^\s+/g, '');
        setSearch(value);
        if (value.length > 0)
        {
            if (props.setShowSearchRec != undefined)
            {
                props.setShowSearchRec(true);
            }
            let modifyList = [];
            let finalData=allListData.length>0?allListData:listData;
            finalData.forEach((item) =>
            {
                let data = item.actualData;
                let keys = Object.keys(data);
                keys.forEach((key) =>
                {
                    if (
                        typeof data[key] === 'string' &&
                        data[key].toLowerCase().indexOf(value.toLowerCase()) >
                        -1
                    )
                    {
                        if (modifyList.indexOf(item) == -1)
                            modifyList.push(item);
                    }
                });
            });
            setFilterListData(modifyList);
            // props.filterListData(modifyList)
        } else
        {
            if (props.setShowSearchRec != undefined)
            {
                props.setShowSearchRec(false);
            }
            setFilterListData(listData);
            // props.filterListData(listData)
        }
    };
    const onCheckSelect = (event, index) =>
    {
        let newFilterList = [...filterListData];
        newFilterList[index]['selected'] = event.target.checked;
        if (checkAllSelect === true)
        {
            if (event.target.checked === true)
            {
                setCheckAllSelect(true)
            } else
            {
                setCheckAllSelect(false)
            }
        } else
        {
            let filteredAllSelect = filterListData.filter(item => item.selected === false);
            if (filteredAllSelect.length === 0)
            {
                setCheckAllSelect(true)
            } else
            {
                setCheckAllSelect(false)
            }
        }

        setFilterListData(newFilterList);
    };
    const statusValues = (value, status) =>
    {
        return (<Box
            className={
                classes.wrapper
            }
            style={{
                fontSize: 14,
            }}
        >
            <CircleIcon
                style={{
                    color: status === 'Pending' ? '#C59B64' : status === 'Approved' ? '#169D3C' : "red",
                }}
                className={
                    classes.icon
                }
            />
            <Typography
                component="span"
                className={
                    classes.count
                }>
                {value}
            </Typography>
        </Box>)
    }
    const onCheckSelectAll = (e) =>
    {
        let newFilterList = [...filterListData];
        newFilterList.map((item) =>
        {
            return item.selected = e.target.checked
        })
        setCheckAllSelect(e.target.checked)
        setFilterListData(newFilterList);
    }


    return (
        <Box className={classes.boxContent}>
            <Title title={props.moduleToShow} />
            {props.moduleToShow != undefined &&
                eventState.eventDetail.get() &&
                ((moduleIndex.get() >= 0 &&
                    eventState.eventDetail.get().moduleDetails[
                        moduleIndex.get()
                    ].details != null) ||
                    '') && (
                    <DetailsComponent
                        data={
                            eventState.eventDetail.get().moduleDetails[
                                moduleIndex.get()
                            ].details
                        }
                    />
                )}
            <EnhancedTableToolbar
                {...props}
                search={search}
                showSendAll={props.showSendAll ? true : false}
                sendAllbuttonTitle={props.showSendAll ? 'Send All' : null}
                showEdit={false}
                editButtonTitle={false}
                handleSearchChange={handleOnChange}
                handleSendEmail={props.handleSendEmail}
                hideAdd={props.hideAdd}
                modPermission={'FULL'}
                // modPermission={props.modPermission}
                disableAdd={props.disableAdd}
                showExport={true}
                hideDelete={props.hideDelete}
                deleteRows={props.deleteRows}
                handleClick={props.handleClick}
            />
            <Box component="div"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '350px',
                    mb: 1
                }}
            >
                {props.showRequestStatus ? (
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={14}
                        fontWeight={600}>
                        Pending : {statusValues(props.showRequestStatus.Pending, 'Pending')}
                    </Typography>
                ) : null}
                {props.showRequestStatus ? (
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={14}
                        fontWeight={600}>
                        Approved : {statusValues(props.showRequestStatus.Approved, 'Approved')}
                    </Typography>
                ) : null}
                {props.showRequestStatus ? (
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={14}
                        fontWeight={600}>
                        Rejected : {statusValues(props.showRequestStatus.Rejected, 'Rejected')}
                    </Typography>
                ) : null}
            </Box>
            {/* <List className={classes.listContent}> */}
            {filterListData && filterListData.length > 0 &&
                <ListItem className={classes.listItemContent}>
                    <Box
                        sx={{ width: '100%', ml: 1, display: 'flex' }}>
                        <Checkbox
                            // color="secondary"
                            checked={checkAllSelect}
                            className={classes.checkbox_style}
                            onChange={e => onCheckSelectAll(e)}
                            value={checkAllSelect}
                        />
                        <Typography sx={{ mt: 1 }}> Select All</Typography>
                    </Box>
                </ListItem>
            }
            {filterListData && filterListData.length > 0 ? (
                filterListData.map((item, index) => (
                    <DataSocialResRow
                        key={`datarow_${index}`}
                        item={item}
                        index={index}
                        onCheckSelect={onCheckSelect}
                        showEdit={props.showEdit ? true : false}
                        editRow={props.editRow}
                        socialInfo={props.options}
                        onActionClick={props.onActionClick}
                        onPendingAction={props.onPendingAction}
                        showHistory={props.showHistory}
                    />
                ))
            ) : (
                <ListItem className={classes.listItemContent}>
                    <Card
                        classes={{ root: classes.paperContent }}
                        sx={{ width: '100%' }}>
                        <CardContent
                            sx={{ p: 2 }}
                            className={classes.cardContent}>
                            <Box className={classes.rowContent}>
                                No data found
                            </Box>
                        </CardContent>
                    </Card>
                </ListItem>
            )}
            {/* </List> */}

            {!props.loading && props.pagingInfo &&
                props.pagingInfo.noOfPages > 1 &&
                !props.showSearchRec ? (
                <Box
                    sx={{
                        p: 2,
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                    <Paging
                        pagingInfo={props.pagingInfo}
                        handlePageChange={props.handlePageChange}
                    />
                </Box>
            ) : null}
        </Box>
    );
};
export default DataSocialResList;
